import { render, staticRenderFns } from "./WaterCompositionAdd.vue?vue&type=template&id=506af8f1&scoped=true&"
import script from "./WaterCompositionAdd.vue?vue&type=script&lang=js&"
export * from "./WaterCompositionAdd.vue?vue&type=script&lang=js&"
import style0 from "./WaterCompositionAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506af8f1",
  null
  
)

export default component.exports